import { useEffect, useState } from "react";
import api from "../api";

export default function KanbanRiunioni() {
  const [cfg, setCfg] = useState(null);
  const [edit, setEdit] = useState(false);
  const [url, setUrl] = useState("");
  const [pwd, setPwd] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/kanban/config").then((r) => { setCfg(r.data); setUrl(r.data.url); setPwd(r.data.password); }).catch(() => {});
  }, []);

  const save = async () => {
    await api.put("/kanban/config", { url, password: pwd });
    setCfg({ url, password: pwd });
    setEdit(false);
  };

  const copyPwd = async () => {
    try { await navigator.clipboard.writeText(cfg.password); setCopied(true); setTimeout(() => setCopied(false), 2000); } catch {}
  };

  if (!cfg) return <div className="page"><p className="muted">Caricamento…</p></div>;

  const src = cfg.password
    ? cfg.url + (cfg.url.includes("?") ? "&" : "?") + "pw=" + encodeURIComponent(cfg.password)
    : cfg.url;

  const isMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <div className="page" style={{ display: "flex", flexDirection: "column", height: "calc(100dvh - 24px)", paddingBottom: 0 }}>
      <div className="toolbar" style={{ gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
        <h1 style={{ margin: 0, fontSize: 22 }}>📋 Kanban riunioni</h1>
        <div className="spacer" />
        {cfg.password && (
          <button className="btn sm" onClick={copyPwd} data-testid="kanban-copy-pwd">{copied ? "✓ Copiata" : "🔑 Copia password"}</button>
        )}
        <a className="btn sm" href={cfg.url} target="_blank" rel="noreferrer" data-testid="kanban-open-tab">↗ Apri in nuova scheda</a>
        <button className="btn sm" onClick={() => setEdit(!edit)} data-testid="kanban-edit-btn">⚙️ Indirizzo</button>
      </div>
      {edit && (
        <div className="panel" style={{ marginBottom: 8 }} data-testid="kanban-config-panel">
          <p className="muted" style={{ marginTop: 0, fontSize: 12.5 }}>
            L'indirizzo trycloudflare cambia a ogni riavvio del tunnel sul tuo computer: quando la pagina non si carica più, incolla qui quello nuovo.
          </p>
          <div className="toolbar" style={{ gap: 8, flexWrap: "wrap" }}>
            <input style={{ flex: 1, minWidth: 260 }} value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://…trycloudflare.com/login" data-testid="kanban-url-input" />
            <input style={{ maxWidth: 180 }} value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="password (opzionale)" data-testid="kanban-pwd-input" />
            <button className="btn primary sm" onClick={save} data-testid="kanban-save-btn">Salva</button>
          </div>
        </div>
      )}
      {isMobile ? (
        <div className="panel" style={{ textAlign: "center", padding: "40px 20px" }} data-testid="kanban-mobile-panel">
          <p style={{ fontSize: 40, margin: "0 0 8px" }}>📋</p>
          <p style={{ margin: "0 0 6px", fontWeight: 600 }}>Apri la kanban a schermo intero</p>
          <p className="muted" style={{ fontSize: 13, margin: "0 0 18px" }}>
            Su iPhone e iPad la kanban si apre in una pagina dedicata (Safari blocca l'accesso automatico dentro i riquadri). Entrerai senza password.
          </p>
          <a className="btn primary" href={src} target="_blank" rel="noreferrer" data-testid="kanban-mobile-open" style={{ fontSize: 16, padding: "12px 26px" }}>
            Apri Kanban riunioni ↗
          </a>
        </div>
      ) : (
        <iframe title="Kanban riunioni" src={src} data-testid="kanban-iframe"
          style={{ flex: 1, width: "100%", border: "1px solid rgba(255,255,255,.12)", borderRadius: 12, background: "#fff" }} />
      )}
    </div>
  );
}
